import { map } from 'lodash';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';

export const SERVING_TYPE = ['INCLUDE', 'EXCLUDE'];
export const servingTypeOptions = map(SERVING_TYPE).map(key => ({
    value: key,
    label: <FormattedMessage id={`campaign.editor.schedule.dayparting.serving.type.${key}`} defaultMessage={key} />,
}));
